import ToolbarIcon from "../../../controls/ToolbarIcon";
import { ComponentEx, connect } from "../../../controls/ComponentEx";
import { getSafe } from "../../../util/storeHelper";
import { setGameHidden } from "../actions/settings";
import * as React from "react";
class HideGameIcon extends ComponentEx {
    render() {
        const { buttonType, instanceId, gamesDiscovered } = this.props;
        const t = this.context.api.translate;
        const hidden = getSafe(gamesDiscovered, [instanceId, "hidden"], false);
        const icon = hidden ? "show" : "hide";
        const text = hidden ? t("Show") : t("Hide");
        return (React.createElement(ToolbarIcon, { id: `hide-${instanceId}`, icon: ["icon", "both"].indexOf(buttonType) !== -1 ? icon : undefined, text: ["text", "both"].indexOf(buttonType) !== -1 ? text : undefined, onClick: this.toggleHidden }));
    }
    toggleHidden = () => {
        const { instanceId, gamesDiscovered, onSetGameHidden } = this.props;
        const hidden = getSafe(gamesDiscovered, [instanceId, "hidden"], false);
        onSetGameHidden(instanceId, !hidden);
    };
}
function mapStateToProps(state) {
    return {
        gamesDiscovered: state.settings.gameMode.discovered,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetGameHidden: (gameId, hidden) => dispatch(setGameHidden(gameId, hidden)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(HideGameIcon);
